
import { 
    EDIT_PAYER_CONFIGURATION,
    EDIT_PAYER_CONFIGURATION_SUCCESS,
    EDIT_PAYER_CONFIGURATION_FAIL, 
    EDIT_PAYER_CONFIGURATION_RESET,
} from "../actions/editPayerConfigurationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editPayerConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_PAYER_CONFIGURATION:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_PAYER_CONFIGURATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_PAYER_CONFIGURATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_PAYER_CONFIGURATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editPayerConfigurationReducer;
